module.exports = __webpack_public_path__ + "img/10n.d449c367.png";